import * as React from 'react';

import { getPropsLandingBlockThreeContainer } from './landing-block-three-container.props';

export const LandingBlockThreeContainerPrintable: React.FC<{
  id?: string;
}> = ({ id }) => {
  const props = getPropsLandingBlockThreeContainer();

  return (
    <>
      {props.sections.map((section) => {
        return id === section.id ? (
          <div
            className="is-printable-section"
            key={section.id}
            role="Sectionpanel"
            id={`Sectionpanel-${section.id}`}
            aria-labelledby={`Section-${section.id}`}
          >
            {section.content}
          </div>
        ) : null;
      })}
    </>
  );
};
